import api from "../index"

const permissionApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPermissionList: build.query({
      query: (params) => ({
        url: `/permissions`,
        method: "GET",
        params,
      }),
    }),
    createPermission: build.mutation({
      query: (body) => ({
        url: `/permissions`,
        method: "POST",
        body,
      }),
    }),
    deletePermission: build.mutation({
      query: ({ id }) => ({
        url: `/permissions/${id}`,
        method: "DELETE",
      }),
    }),
    updatePermission: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/permissions/${id}`,
        method: "POST",
        body: params,
      }),
    }),
  }),
})

export const {
  useLazyGetPermissionListQuery,
  useCreatePermissionMutation,
  useDeletePermissionMutation,
  useUpdatePermissionMutation,
} = permissionApi
